import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(27, 27, 27, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background-color: #FFFFFF;
  border-radius: 8px;
  width: 494px;
  height: 736px;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 0px 24px;
  position: relative;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  color: #3D3D3D;
  font-family: Mangueira;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.542;

  img {
    width: 24px;
    height: 24px;
  }

  &:hover {
    opacity: 0.8;
  }
`;export const CloseButton = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  background: none;
  border: none;
  font-size: 32px;
  color: #3D3D3D;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
`;

export const Content = styled.div`
  padding: 24px;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
`;

export const HeaderTitle = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const ModalTitle = styled.h2`
  font-family: Mangueira;
  font-weight: 700;
  font-size: 20px;
  line-height: 1em;
  text-align: center;
  color: #3D3D3D;
  margin: 0;
`;

export const ModalSubtitle = styled.p`
  font-family: Mangueira;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.542;
  text-align: center;
  color: #636363;
  margin: 0;
`;

export const RatingSection = styled.div`
  width: 100%;
  background-color: #FFFFFF;
  border: 1px solid #CBCBCB;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
`;

export const SectionTitle = styled.h3`
  font-family: Mangueira;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.542;
  text-align: center;
  color: #3D3D3D;
  margin: 0;
`;

export const StarsContainer = styled.div`
  display: flex;
  gap: 13.76px;
  align-items: center;
`;

export const StarIcon = styled.button`
  width: 41.29px;
  height: 39px;
  background: none;
  border: none;
  font-size: 32px;
  cursor: pointer;
  color: ${props => props.filled ? '#FFD700' : '#CBCBCB'};
  transition: color 0.2s ease;

  &:hover {
    color: ${props => props.filled ? '#FFD700' : '#FFE55C'};
  }
`;

export const Separator = styled.div`
  width: 100%;
  height: 0px;
  border-top: 1px dashed #CBCBCB;
`;

export const CommentsSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CommentsTitle = styled.h4`
  font-family: Mangueira;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.542;
  color: #3D3D3D;
  margin: 0;
`;

export const CommentsContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: visible;
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 129px;
  background-color: #FFFFFF;
  border: 1px solid #CBCBCB;
  border-radius: 8px;
  padding: 12px;
  font-family: Mangueira;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.611;
  color: #3D3D3D;
  resize: none;
  outline: none;
  box-sizing: border-box;

  &::placeholder {
    color: #CBCBCB;
  }

  &:focus {
    border-color: #0B29FB;
  }
`;

export const CharacterCount = styled.div`
  position: absolute;
  bottom: 12px;
  right: 12px;
  font-family: Mangueira;
  font-weight: 500;
  font-size: 13px;
  line-height: 1.2;
  color: #636363;
  pointer-events: none;
  z-index: 10;
`;

export const Footer = styled.div`
  padding: 24px;
  background-color: #FFFFFF;
  border-top: none;

  border-radius: 0px 0px 8px 8px;
`;

export const FooterButton = styled.button`
  width: 100%;
  height: 40px;
  background-color: ${props => props.disabled ? '#CBCBCB' : '#0B29FB'};
  border: 1px solid ${props => props.disabled ? '#CBCBCB' : '#0B29FB'};
  border-radius: 5.33px;
  color: #FFFFFF;
  font-family: Mangueira;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.542;
  text-align: center;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => props.disabled ? '#CBCBCB' : '#0A25E8'};
  }
`;

export const ValidationMessageError = styled.div`
  font-size: 12px;
  color: #D32F2F;
  margin-top: 8px;
`;

export const ValidationMessageInfo = styled.div`
  font-size: 12px;
  color: #999;
  margin-top: 8px;
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`;
